import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/ambulatorio`

    const headers = {responseType: "arraybuffer"}

    return {
        acolhimentoAcsTacs(id) {
            return repository.get(`${baseUrl}/acolhimento-acs-tacs/${id}`, headers)
        },
        acolhimentoSaudeBucal(id) {
            return repository.get(`${baseUrl}/acolhimento-saude-bucal/${id}`, headers)
        },
        agendamento(id) {
            return repository.get(`${baseUrl}/agendamento/${id}`, headers)
        },
        agendamentoExterno(id) {
            return repository.get(`${baseUrl}/agendamento-externo/${id}`, headers)
        },
        declaracaoComparecimento(id, queryParms = {}) {
            return repository.get(`${baseUrl}/declaracao-comparecimento/${id}?${urlUtil.serialize(queryParms)}`, headers)
        },
        geral(id, queryParms) {
            return repository.post(`${baseUrl}/geral/${id}`, queryParms, headers)
        },
        assinados(id, queryParms) {
            return repository.get(`${baseUrl}/assinado/${id}?${urlUtil.serialize(queryParms)}`, headers)
        },
        preAtendimento(id) {
            return repository.get(`${baseUrl}/pre-atendimento/${id}`, headers)
        },
        posConsulta(id) {
            return repository.get(`${baseUrl}/pos-consulta/${id}`, headers)
        },
        atendimento(id, queryParms) {
            return repository.get(`${baseUrl}/atendimento/${id}?${urlUtil.serialize(queryParms)}`, headers)
        },
        cartaMedica(id, queryParms = {}) {
            return repository.get(`${baseUrl}/carta-medica/${id}?${urlUtil.serialize(queryParms)}`, headers)
        },
        confirmacaoConsulta(params) {
            return repository.post(`${baseUrl}/confirmacao-consulta`, params, headers)
        },
        receitaMedicaComum(id, params) {
            return repository.post(`${baseUrl}/receita-medica-comum/${id}`, params, headers)
        },
        receitaMedicaEspecial(id, params) {
            return repository.post(`${baseUrl}/receita-medica-especial/${id}`, params, headers)
        },
        laudoMedicamentos(id, params) {
            return repository.post(`${baseUrl}/laudo-medicamento/${id}`, params, headers)
        },
        laudoSolicitacaoAutorizacaoProcedimentoAmbulatorial(id, params = {}) {
            return repository.post(`${baseUrl}/laudo-solicitacao-autorizacao-procedimento-ambulatorial/${id}`, params, headers)
        },
        fichaRequisicaoServicoAuxiliarDiagnoseTerapia(id, params = {}) {
            return repository.post(`${baseUrl}/ficha-requisicao-servico-auxiliar-diagnose-terapia/${id}`, params, headers)
        },
        servicoAnaliseDiagnosticoTerapiaSolicitacaoExame(id, params) {
            return repository.post(`${baseUrl}/servico-analise-diagnostico-terapia-solicitacao-exame/${id}`, params, headers)
        },
        requisicaoExameCitopatologicoColoUtero(id, queryParms) {
            return repository.get(`${baseUrl}/requisicao-exame-citopatologico-colo-utero/${id}?${urlUtil.serialize(queryParms)}`, headers)
        },
        requisicaoExameCitopatologicoMama(id, queryParms) {
            return repository.get(`${baseUrl}/requisicao-exame-citopatologico-mama/${id}?${urlUtil.serialize(queryParms)}`, headers)
        },
        requisicaoExameHistopatologicoMamografia(id) {
            return repository.get(`${baseUrl}/requisicao-exame-histopatologico-mamografia/${id}`, headers)
        },
        receitaMedicaEspecialAzul(id, params) {
            return repository.post(`${baseUrl}/receita-medica-especial-azul/${id}`, params, headers)
        },
        receitaMedicaEspecialAmarela(id, params) {
            return repository.post(`${baseUrl}/receita-medica-especial-amarela/${id}}`, params, headers)
        },
        relatorioEstatisticoConsulta(queryParms) {
            return repository.get(`${baseUrl}/relatorio-estatistico-consulta?${urlUtil.serialize(queryParms)}`, headers)
        },
        listagemConsultaAgendadaRealizada(params) {
            return repository.post(`${baseUrl}/listagem-consulta-agendada-realizada`, params, headers)
        },
        relatorioQuantitativoAtendimento(params) {
            return repository.post(`${baseUrl}/relatorio-quantitativo-atendimento`, params, headers)
        },
        relatorioQuantitativoProducao(queryParms) {
            return repository.get(`${baseUrl}/relatorio-quantitativo-producao?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioQuantitativoCid(queryParms) {
            return repository.get(`${baseUrl}/relatorio-quantitativo-cid?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioProducaoAmbulatorial(queryParms) {
            return repository.get(`${baseUrl}/relatorio-producao-ambulatorial?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioProcedimentoLancadoPeriodo(queryParms) {
            return repository.get(`${baseUrl}/relatorio-procedimento-lancado-periodo?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioIdentificacao(queryParms) {
            return repository.get(`${baseUrl}/relatorio-identificacao?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioEstatisticoStatus(queryParms) {
            return repository.get(`${baseUrl}/relatorio-estatistico-status?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioEstatisticoPaciente(queryParms) {
            return repository.get(`${baseUrl}/relatorio-estatistico-paciente?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioQuantitativoConsultaSolicitada(queryParms) {
            return repository.get(`${baseUrl}/relatorio-quantitativo-consulta-solicitada?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioConsultaSolicitada(queryParms) {
            return repository.get(`${baseUrl}/relatorio-consulta-solicitada?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioQuantitativoProcedimento(queryParms) {
            return repository.get(`${baseUrl}/relatorio-quantitativo-procedimento?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioProcedimento(queryParms) {
            return repository.get(`${baseUrl}/relatorio-procedimento?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioConsultaFinalizada(queryParms) {
            return repository.get(`${baseUrl}/relatorio-consulta-finalizada?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioPacienteAtendimento(queryParms) {
            return repository.get(`${baseUrl}/relatorio-paciente-atendimento?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioJornada(queryParms) {
            return repository.get(`${baseUrl}/relatorio-jornada?${urlUtil.serialize(queryParms)}`, headers)
        },
        atestado(id, queryParms = {}) {
            return repository.get(`${baseUrl}/atestado/${id}?${urlUtil.serialize(queryParms)}`, headers)
        },
        receitaMedicaNaoPadronizadaComum(id, params) {
            return repository.post(`${baseUrl}/receita-medica-nao-padronizada-comum/${id}`, params, headers)
        },
        receitaMedicaNaoPadronizadaEspecial(id, params) {
            return repository.post(`${baseUrl}/receita-medica-nao-padronizada-especial/${id}`, params, headers)
        },
        orientacao(id, queryParms = {}) {
            return repository.get(`${baseUrl}/orientacao/${id}?${urlUtil.serialize(queryParms)}`, headers)
        },
        encaminhamento(id, params) {
            return repository.post(`${baseUrl}/encaminhamento/${id}`, params, headers)
        },
        encaminhamentoHospitalar(id, params) {
            return repository.post(`${baseUrl}/encaminhamento-hospitalar/${id}`, params, headers)
        },
        fichaNotificacao(id, queryParms = {}) {
            return repository.get(`${baseUrl}/ficha-notificacao/${id}?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioRastreioFerida(queryParms) {
            return repository.get(`${baseUrl}/relatorio-rastreio-ferida?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioCancelamento(queryParms) {
            return repository.get(`${baseUrl}/relatorio-cancelamento?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioTempoAtendimento(queryParms) {
            return repository.get(`${baseUrl}/relatorio-tempo-atendimento?${urlUtil.serialize(queryParms)}`, headers)
        },
        listaAgendamento(queryParms) {
            return repository.get(`${baseUrl}/lista-agendamento?${urlUtil.serialize(queryParms)}`, headers)
        },
        requisicaoMamografia(id, queryParms) {
            return repository.get(`${baseUrl}/requisicao-mamografia/${id}?${urlUtil.serialize(queryParms)}`, headers)
        },
        laudoMChatR(atendimentoId, soapId = null, queryParms = {}) {
            return repository.get(`${baseUrl}/laudo-m-chat-r/${atendimentoId}/${soapId}?${urlUtil.serialize(queryParms)}`, headers)
        },
        agendamentoDemandaEspontanea(queryParms) {
            return repository.get(`${baseUrl}/agendamento-demanda-espontanea?${urlUtil.serialize(queryParms)}`, headers)
        },
    }
}
